const CHANGELOG_LINKS = {
  JIRA_CLOUD: {
    IFRAME: 'https://oboard.io/page-iframe?jira-cloud',
    SOURCE: 'https://oboard.io/changelog?jira-cloud'
  },

  CROSS_PLATFORM: {
    IFRAME: 'https://oboard.io/page-iframe?oboard-web-app',
    SOURCE: 'https://oboard.io/changelog?oboard-web-app'
  },

  WEB_APP: {
    IFRAME: 'https://oboard.io/page-iframe?oboard-web-app',
    SOURCE: 'https://oboard.io/changelog?oboard-web-app'
  },

  AZURE: {
    IFRAME: 'https://oboard.io/page-iframe?ms-azure-devops',
    SOURCE: 'https://oboard.io/changelog?ms-azure-devops'
  }
}

export const getCurrentPlatformChangelogLinks = ({
  isJiraApp = true,
  isWebApp = false,
  isCrossPlatformApp = false,
  isAzureApp = false
} = {}) => {
  const { JIRA_CLOUD, CROSS_PLATFORM, WEB_APP, AZURE } = CHANGELOG_LINKS

  const [links] = [
    isJiraApp && JIRA_CLOUD,
    isWebApp && WEB_APP,
    isCrossPlatformApp && CROSS_PLATFORM,
    isAzureApp && AZURE,
    JIRA_CLOUD
  ].filter(Boolean)

  return links
}
